declare global {
  /**
   * Runtime config from /env.js, rendered when the image starts. Apps add
   * their own keys by augmenting this interface.
   */
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface AppEnv {
    readonly ENVIRONMENT: string
    readonly RELEASE: string
    readonly SENTRY_DSN: string
    readonly HUGINN_ID: string
  }

  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    readonly env: AppEnv
  }
}

export default (envName: keyof AppEnv) =>
  typeof window !== "undefined" ? window.env[envName] : ""
